import * as DashboardConstants from '../../../components/Dashboards/DashboardConstants';
export const headerData = [
    {
        key: 'client_name',
        header: `${DashboardConstants.ClientName}`,
    },
    {
        key: 'project_id',
        header: `${DashboardConstants.ProjectID}`,
    },
    {
        key: 'account_id',
        header: `${DashboardConstants.AccountID}`,
    },
    {
        key: 'billing_period',
        header: `${DashboardConstants.BillingPeriod}`,
    },
    {
        key: 'billing_month',
        header: `${DashboardConstants.BillingMonth}`,
    },
    {
        key: 'date_od_issue',
        header: `${DashboardConstants.DateOfIssue}`,
    },
    {
        key: 'alerts',
        header: `${DashboardConstants.Alerts}`,
    },
    {
        key: 'invoice_amount',
        header: `${DashboardConstants.InvoiceAmount}`,
    },   
];

export const invoiceHeaderData = [
    {
        key: 'client_name',
        header: `${DashboardConstants.ClientName}`,
    },
    {
        key: 'project_id',
        header: `${DashboardConstants.ProjectID}`,
    },
    {
        key: 'account_id',
        header: `${DashboardConstants.AccountID}`,
    },
    {
        key: 'cnum_id',
        header: `${DashboardConstants.CnumID}`,
    },
    {
        key: 'alerts',
        header: `${DashboardConstants.AlertVolumeOfCurrentBillingPeriod}`,
    },
    {
        key: 'alert_volume_last_month',
        header: `${DashboardConstants.AlertVolumeOfLastBillingPeriod}`,
    },
    {
        key: 'billing_period',
        header: `${DashboardConstants.CostIncurredDate}`,
    },
    {
        key: 'adjustment_for_last_month',
        header: `${DashboardConstants.AdjustmentForLastMonth}`,
    },
    {
        key: 'final_amount',
        header: `${DashboardConstants.FinalAmount}`,
    },
    {
        key: 'remarks',
        header: `${DashboardConstants.Remarks}`,
    },   
];
